<template>
  <div v-for="textUser in textUsers">
    <v-menu :disabled="readonly" width="400">
      <template #activator="{ props }">
        <v-btn-icon v-bind="props" :readonly="readonly" size="24">
          <v-icon size="small">{{ virtualParticipantsIcons[textUser] || defaultIcon }}</v-icon>
        </v-btn-icon>
      </template>
      <v-card v-if="! readonly" class="pa-2 d-flex align-center flex-wrap">
        <div class="pa-1 pointer" @click="setVirtualParticipantIcon(textUser, defaultIcon)">
          <v-icon size="small" :color="virtualParticipantsIcons[textUser] ? 'warningorange' : 'successgreen'">{{ defaultIcon }}</v-icon>
        </div>
        <div v-for="icon in availableIcons" :key="icon" class="pa-1 pointer" @click="setVirtualParticipantIcon(textUser, icon)">
          <v-icon size="small" :color="virtualParticipantsIcons[textUser] == icon ? 'successgreen' : null">{{ icon }}</v-icon>
        </div>
      </v-card>
    </v-menu>
  </div>
</template>

<script>
  import { getDefaultIcons } from '@/models/helpers/defaultConfigData';
  import useUsersAccessRightStore from '@/stores/users/accessRight';

  export default {
    props: {
      textUsers: { type: Array, required: true },
      readonly: { type: Boolean, default: false },
    },
    data() {
      return {
        defaultIcon: 'far fa-bullseye',
      };
    },
    computed: {
      availableIcons() {
        const icons = new Set(Object.values(getDefaultIcons()).map(icon => icon.name.replace('fas', 'far')));
        return [...icons].filter(item => item.startsWith('far ')); // remove diamonds and youtube
      },
      virtualParticipantsIcons() {
        return this.computedConfig.virtualParticipantsIcons || {};
      },
      computedConfig() {
        return useUsersAccessRightStore().config;
      },
    },
    watch: {
      textUsers(newVal, oldVal) {
        if (newVal?.length != oldVal?.length) return;
        let modified = false;
        oldVal.forEach((oldTextUser, index) => {
          const newTextUser = newVal[index];
          if (newTextUser != oldTextUser && this.virtualParticipantsIcons[oldTextUser]) {
            this.virtualParticipantsIcons[newTextUser] = this.virtualParticipantsIcons[oldTextUser];
            delete this.virtualParticipantsIcons[oldTextUser];
            modified = true;
          }
        });
        if (modified) this.setParam('virtualParticipantsIcons', this.virtualParticipantsIcons);
      },
    },
    methods: {
      setVirtualParticipantIcon(textUser, icon) {
        this.virtualParticipantsIcons[textUser] = icon;
        if (icon == this.defaultIcon) delete this.virtualParticipantsIcons[textUser];
        this.setParam('virtualParticipantsIcons', this.virtualParticipantsIcons);
      },
      setParam(prop, val) {
        useUsersAccessRightStore().updateBusinessConfig({ [prop]: val });
      },
    },
  };
</script>
